module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-2-2x-142cb8d8ec97b7e647bf983dba81499f.jpg";